import React, { useState, useEffect } from "react";
import ReactExport from "react-data-export";
import Styles from './Styles';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const Download = props => {
    const [ dataSet, setDataSet ] = useState([{
        columns:[],
        data:[]
    }]);

    const [ dataSet2, setDataSet2 ] = useState([{
        columns:[],
        data:[]
    }]);

    useEffect(() => {
        formatData();
        formatData2()
    },[props.data])

    if (props.loading) {
        return null
    };

    const formatData = () => {
        let label;
        if (props.data.length > 0) {
            label = Object.keys(props.data[0]);
        } else {
            label = Object.keys([]);
        };
    
        const columns = label.reduce((r,i) => {
            r.push({
                title:i, 
                style:Styles.shippingDetailLabelStyle
            });
            return r;
        },[]);
    
        let totalItem = props.data.length;
        let totalPrice = 0; 
        let totalQuantity = 0; 
        let style = Styles.shippingDetailRowLightStyle;
        const data = props.data.reduce((r,i,idx) => {      
            totalPrice = totalPrice + i.price;
            totalQuantity = totalQuantity + i.quantity;
            style = style === Styles.shippingDetailRowLightStyle ? Styles.shippingDetailRowDarkStyle : Styles.shippingDetailRowLightStyle;

            r.push([
                {value:i.name,style},
                {value:i.details,style},
                {value:i.sku,style},
                {value:i.status,style},
                {value:i.time,style},
                {value:i.length,style},
                {value:i.width,style},
                {value:i.height,style},
                {value:i.quantity,style},
                {value:i.price,style},
            ]);

            if (idx+1 === totalItem) {
                style = Styles.shippingDetailRowLightStyle;
                r.push([
                    {value:"",style},
                    {value:"",style},
                    {value:"",style},
                    {value:"",style},
                    {value:"",style},
                    {value:"",style},
                    {value:"",style},
                    {value:"Total", style:Styles.fontBoldCell},
                    {value:totalQuantity, style:Styles.fontBoldCell},
                    {value:totalPrice, style:Styles.fontBoldCell},
                ]);
            } 
            return r;
        },[])
        setDataSet([{
            columns,
            data
        }])
    }

    const formatData2 = () => {
        let label;
        if (props.data2.length > 0) {
            label = Object.keys(props.data2[0]);
        } else {
            label = Object.keys([]);
        };
    
        const columns = label.reduce((r,i) => {
            r.push({
                title:i, 
                style:Styles.shippingDetailLabelStyle
            });
            return r;
        },[]);
    
        let style = Styles.shippingDetailRowLightStyle;
        const data = props.data2.reduce((r,i,idx) => {      
            style = style === Styles.shippingDetailRowLightStyle ? Styles.shippingDetailRowDarkStyle : Styles.shippingDetailRowLightStyle;

            r.push([
                {value:i.sku,style},
                {value:i.inbound_date,style},
                {value:i.inbound_time,style},
                {value:i.outbound_date,style},
                {value:i.outbound_time,style},
                {value:i.time_in_storage,style},
                {value:i.time_in_storage_unit,style},
                {value:i.status,style}
            ]);

            return r;
        },[])
        setDataSet2([{
            columns,
            data
        }])
    }

    return (
        <div className={props.className}>
            <ExcelFile filename={props.filename} element={<button className={`btn btn-primary btn-block ${props.buttonClassName}`}>{props.title}</button>}>
                <ExcelSheet dataSet={dataSet} name="Fulfillment Summary"/>
                <ExcelSheet dataSet={dataSet2} name="Storage Breakdown"/>
            </ExcelFile>
        </div>
    );
}

export default Download;